import React from 'react';
import PropTypes from 'prop-types';
import Mentions from 'rc-mentions';
import { injectIntl } from 'react-intl';
import classnames from 'classnames';

export const NOTES_TEXT_AREA_BLOCK = 'notes-text-area';

const NotesTextArea = ({ intl, onChange, value, data, placeholder }) => {
  // Transform data format for rc-mentions - use display property
  const mentionOptions = data.map((item) => ({
    value: item.display,
    label: item.display, // Keep label as plain text for dropdown display
    key: item.id,
    id: item.id,
    ...item,
  }));

  // Convert span tags back to clean display for textarea
  const displayValue = (value || '').replace(
    /<span cfto_user_id="[^"]*">@([^<]+)<\/span>/g,
    '@$1',
  );

  const handleChange = (val) => {
    // Convert mentions to span tags
    let processedVal = val;

    // Replace @username with span tags
    data.forEach((user) => {
      const mentionText = '@' + user.display;
      const spanTag =
        '<span cfto_user_id="' + user.id + '">@' + user.display + '</span>';

      if (processedVal.includes(mentionText)) {
        processedVal = processedVal.split(mentionText).join(spanTag);
      }
    });

    onChange(processedVal);
  };

  return (
    <Mentions
      value={displayValue}
      placeholder={intl.formatMessage({
        id: placeholder,
      })}
      onChange={handleChange}
      prefix="@"
      split=" "
      options={mentionOptions}
      filterOption={(input, option) => {
        // Handle empty input - show all options
        if (!input || input.trim() === '') {
          return true;
        }
        // Use option.label for filtering (which is now set to display)
        if (!option || !option.label) {
          return false;
        }
        return option.label.toLowerCase().includes(input.toLowerCase());
      }}
      placement="bottom"
    ></Mentions>
  );
};

NotesTextArea.propTypes = {
  /** event handler for handling changes in the text box */
  onChange: PropTypes.func.isRequired,
  /** Current value of the text area*/
  value: PropTypes.string.isRequired,
  /** a list of elements to render on the suggestions tab*/
  data: PropTypes.array.isRequired,
  /** the default text to be render in the text box*/
  placeholder: PropTypes.string.isRequired,
};

export default injectIntl(NotesTextArea);
